import {Decoder, Result} from '@mojotech/json-type-validation';

import {isDevelopmentMode} from 'config/staticConfig';

/**
 * Attempt to validate the response with the given decoder. On failure catch
 * the error and pass the bad data through, but log errors to the console.
 */
export function decodeResponse<T>(decoder: Decoder<T>, response: any): T {
  if (isDevelopmentMode) {
    const decoderResult = decoder.run(response);

    if (Result.isErr(decoderResult)) {
      const err = decoderResult.error;
      // eslint-disable-next-line no-console
      console.warn(`Error at ${err.at}: ${err.message}`, err.input);
    }
  }

  return response;
}
